<template>
  <span class="number-counter" ref="counterRef">{{ displayValue }}</span>
</template>

<script>
export default {
  name: 'NumberCounter',
  props: {
    target: {
      type: Number,
      required: true
    },
    suffix: {
      type: String,
      default: ''
    },
    duration: {
      type: Number,
      default: 1200
    },
    startAnimation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayValue: this.suffix === '+' ? '0+' : this.suffix === '%' ? '0%' : '0',
      hasAnimated: false
    }
  },
  watch: {
    startAnimation: {
      handler(newVal) {
        console.log(6666);
        if (newVal && !this.hasAnimated) {
          console.log(9999);
          this.animate()
          this.hasAnimated = true
        }
      },
      immediate: true
    }
  },
  methods: {
    animate() {
      const start = 0
      const increment = this.target / (this.duration / 16)
      let current = start

      const timer = setInterval(() => {
        current += increment
        if (current >= this.target) {
          current = this.target
          clearInterval(timer)
        }

        const numValue = Math.floor(current)
        if (this.suffix === '%') {
          this.displayValue = numValue + '%'
        } else if (this.suffix === '+') {
          this.displayValue = numValue + '+'
        } else if (this.suffix === '项') {
          this.displayValue = numValue + '项'
        } else if (this.suffix === '次') {
          this.displayValue = numValue + '次'
        } else {
          this.displayValue = numValue + this.suffix
        }
      }, 16)
    }
  }
}
</script>

<style lang="less" scoped>
.number-counter {
  display: inline-block;
  // font-weight: bold;
  font-weight: normal!important;
  font-family: OutfitFont;
}
</style>
